var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1024,
    zoomAndPan: "magnify",
    viewBox: "0 0 768 767.999994",
    height: 1024,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "36996d754b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 19.429688 19.429688 L 746.929688 19.429688 L 746.929688 746.929688 L 19.429688 746.929688 Z M 19.429688 19.429688 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#36996d754b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#73e2ae",
    d: "M 552.84375 459.207031 C 537.023438 475.027344 511.515625 475.027344 495.691406 459.207031 L 388.878906 352.394531 C 385.714844 349.230469 380.613281 349.230469 377.449219 352.394531 L 270.574219 459.207031 C 254.753906 475.027344 229.179688 475.027344 213.421875 459.207031 C 197.664062 443.511719 197.664062 417.875 213.421875 402.117188 L 343.160156 272.382812 C 365.179688 250.296875 401.085938 250.296875 423.105469 272.382812 L 552.84375 402.117188 C 568.601562 417.875 568.601562 443.511719 552.84375 459.207031 Z M 383.132812 19.429688 C 182.230469 19.429688 19.429688 182.296875 19.429688 383.132812 C 19.429688 583.96875 182.230469 746.835938 383.132812 746.835938 C 584.035156 746.835938 746.835938 583.96875 746.835938 383.132812 C 746.835938 182.296875 584.035156 19.429688 383.132812 19.429688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackTop);
export default __webpack_public_path__ + "static/media/back-top.219e03a1d3e519609ac174f6819f7e01.svg";
export { ForwardRef as ReactComponent };